window.BOLD = window.BOLD || { }
BOLD.BMS = BOLD.BMS || { }

BOLD.BMS.Cart = (function($){

    function find(arr,pred) {
        var returnValue;
        arr.forEach(function(e) {
            if( pred(e) ) {
                returnValue = e;
                return false;
            }
        })
        return returnValue;
    }

    function updateCart(form) {

        $.ajax({
            url:'/cart/update.js',
            data: $(form).serialize(),
            type:'post',
            dataType:'json',
            success:function(cart){
                // cart = BOLD.common.cartDoctor.fix(cart);
              
              	if (window.BOLD 
                    && BOLD.BMS
                    && BOLD.BMS.CartMotivator
                    && BOLD.BMS.CartMotivator.updateMotivatorWidget) {
                	BOLD.BMS.CartMotivator.updateMotivatorWidget(cart);
                }
        
                // Reload the page if user has no items in cart
                if (cart.items.length == 0) {
                    window.location.reload();
                    return
                }
        
                $('.item[data-key]').each(function(){
                    var $this = $(this);
                    var item = find(cart.items, function(e){
                        return e.key == $this.data('key');
                    })
                    if (!item) {
                        $this.remove();
                        return
                    }
                    $this.find('.total').html(Shopify.formatMoney(item.line_price,Shopify.money_format)+' USD');
                })
        
                $('.cartTotal').html(Shopify.formatMoney(cart.total_price,Shopify.money_format)+' USD');
                $('.cart_header .cart_count').html(cart.item_count);
                $('.cart_count_mbl').html(cart.item_count);

                window.BOLD && BOLD.common && BOLD.common.eventEmitter && BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded', cart)
            }
          
          })

    }
    
    // @return {Function} - returns a function to be binded to an event listener
    function debounceEventListener(delay, func) {
        var timeout;

        return function () {
            var args = arguments;
            var _this = this;
            clearTimeout(timeout)
            timeout = setTimeout(function () {
                func.apply(_this, args)
            }, delay, this);
        }
    }
    
    function addEventListeners() {

        var doc = window.document;

        $(doc).on('change', '[name*="updates"]', debounceEventListener(500, function(){
            var form = this.form;
            if(!form){return}
            updateCart(form);
        }))

        $(doc).on('click', '.item .remove a', function(e){
            e.preventDefault();
            var $this = $(this);
            var parent = $this.closest('.item[data-key]');
            var qtyInput = parent.find('.quantity__value');
            qtyInput.val(0).trigger('change');
        })

        $(doc).on('click', '.quantity__minus, .quantity__add', function(e){
            e.preventDefault();
            var $this = $(this);
            var parent = $this.closest('.item[data-key]');
            var qtyInput = parent.find('.quantity__value');
            var currentVal = parseInt(qtyInput.val());
            if ($this.hasClass('quantity__minus')){
                qtyInput.val(currentVal - 1).trigger('change');
            } else if ($this.hasClass('quantity__add')) {
                qtyInput.val(currentVal + 1).trigger('change');
            }
        })

    }

    function init(){
        addEventListeners();
    }

    init();

    return { 
        init:init
    }

})(BOLD.jQuery || jQuery)

// $(function() {
//     $('.item[data-key]').each(function(){
//         $lineItem = $(this);
//         $lineItemPrice = $lineItem.find('.price__wrap .money');
//         $lineItemTotal = $lineItem.find('.total .money')
//         $lineItemPrice.text( $lineItemPrice.text() + ' USD');
//         $lineItemTotal.text( $lineItemTotal.text() + ' USD');
//     });
//     $cartTotal = $('.cartTotal .money');
//     $cartTotal.text( $cartTotal.text() + ' USD');
// });